module.exports = __webpack_public_path__ + "img/114.1e0023f5.jpg";